interface CircularProgressProps {
	size?: number;
}

const CircularProgress: React.FC<CircularProgressProps> = ({ size = 64 }) => {
	return (
		<div className="gap-4 w-full flex items-center justify-center">
			<div
				className="border-4 border-transparent text-4xl animate-spin flex items-center justify-center border-t-primary rounded-full"
				style={{ width: `${size}px`, height: `${size}px` }}
			>
				{size > 24 && (
					<div
						className="border-4 border-transparent text-2xl animate-spin flex items-center justify-center border-t-black rounded-full"
						style={{ width: `${size - 16}px`, height: `${size - 16}px` }}
					></div>
				)}
			</div>
		</div>
	);
};

export default CircularProgress;
